// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1FnY_","buttons":"PendingPaymentAlert_buttons__2qGv_"};